import { Link } from "react-router-dom";
import { useLang, LangSwitch } from "@/i18n/LangContext";
import { usePortal } from "../i18n";
import {useAuth} from '../AuthContext';

export default function ManagedWorkspace({ admin = false }) {
  const { lang } = useLang();
  const { p } = usePortal();
  const {user} = useAuth();
  return <div className="flex h-[100dvh] min-h-[500px] flex-col bg-paper">
    <nav aria-label={p.area} className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-ink/10 bg-white px-5 py-3">
      <div className="flex flex-wrap items-center gap-5 text-sm font-semibold">
        <Link to="/" className="hover:text-signal">← {p.backToSite}</Link>
        <Link to={admin ? "/admin" : "/kundenbereich/anfragen"} className="hover:text-signal">{admin ? p.admin : p.nav.tickets}</Link>
        {!admin && <Link to="/kundenbereich/profil" className="hover:text-signal">{p.nav.profile}</Link>}
        {admin && user?.admin_level === 'owner' && <><Link to="/admin/site-editor" className="hover:text-signal">Редактор сайта</Link><Link to="/admin/workspace-editor" className="hover:text-signal">Редактор кабинета</Link></>}
      </div>
      <LangSwitch testPrefix="workspace-lang" />
    </nav>
    <iframe key={`${admin}-${lang}`} title={admin ? p.admin : p.area} src={`/workspace/${admin ? "admin.html" : "client/index.html"}?lang=${encodeURIComponent(lang)}`} className="min-h-0 w-full flex-1 border-0" />
  </div>;
}
